// "env-config" is a bundler alias resolved to src/config/<env>.ts so the other
// environments' configs never reach the bundle.
import config from "env-config";

export default config;
